import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { pageTransition, pageVariants } from '../constants/pageMotion';
import AnimatedPage from './ui/AnimatedPage';
import PageSectionHeader from './ui/PageSectionHeader';
import PropuestaComparativaCard from './PropuestaComparativaCard';
import DiferenciaClaveCallout from './DiferenciaClaveCallout';
import IconRenderer from './IconRenderer';

export default function Propuestas({ activo, setActivo, data = [] }) {
  if (!activo || data.length === 0) {
    return (
      <div className="flex w-full items-center justify-center px-4 py-16 text-center text-slate-500">
        No hay propuestas disponibles para comparar en este momento.
      </div>
    );
  }

  const puntosCandidatoA = activo.candidatoA?.puntos ?? [];
  const puntosCandidatoB = activo.candidatoB?.puntos ?? [];

  return (
    <AnimatedPage className="flex w-full items-start">
      <aside className="hidden lg:block w-64 bg-white p-8 border-r border-slate-100 sticky top-20 h-[calc(100vh-5rem)] overflow-y-auto">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-6">Análisis de Políticas</h3>
        <nav className="space-y-1">
          {data.map((cat) => (
            <motion.button
              key={cat.id}
              onClick={() => setActivo(cat)}
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all border ${
                activo?.id === cat.id
                  ? 'bg-slate-50 text-slate-900 shadow-sm border-slate-100'
                  : 'text-slate-500 hover:bg-slate-50 border-transparent hover:border-slate-100'
              }`}
            >
              <IconRenderer name={cat.icono} className="h-4 w-4" /> {cat.titulo}
            </motion.button>
          ))}
        </nav>
      </aside>

      <section className="w-full px-4 py-8 md:px-6 md:py-10 lg:flex-1 lg:p-12">
        <PageSectionHeader
          className="max-w-4xl mx-auto mb-12"
          eyebrow="Elecciones-Colombia 2026"
          title={
            <>
              Elecciones Presidenciales <br className="hidden sm:block" /> Segunda Vuelta
            </>
          }
          titleClassName="mt-6 mb-4 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl"
          description="Hacia un voto informado. Compara las propuestas fundamentales de los candidatos para el futuro institucional de Colombia."
          descriptionClassName="mx-auto max-w-xl text-base text-slate-500 sm:text-lg"
        />

        <AnimatePresence mode="wait">
          <motion.div
            key={activo.id}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pageTransition}
            className="max-w-5xl mx-auto"
          >
            <div className="flex items-center gap-3 mb-8">
              <IconRenderer name={activo.icono} className="h-8 w-8 text-slate-700" />
              <h3 className="text-2xl font-bold uppercase tracking-tight">{activo.titulo}</h3>
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <PropuestaComparativaCard
                titulo={activo.candidatoA?.propuestaTitulo}
                puntos={puntosCandidatoA}
                topicId={activo.id}
                candidatoSide="a"
                variant="blue"
              />
              <PropuestaComparativaCard
                titulo={activo.candidatoB?.propuestaTitulo}
                puntos={puntosCandidatoB}
                topicId={activo.id}
                candidatoSide="b"
                variant="red"
              />
            </div>

            <DiferenciaClaveCallout texto={activo.diferenciaClave} />
          </motion.div>
        </AnimatePresence>
      </section>
    </AnimatedPage>
  );
}
